import { Badge, Box } from '@branch-messenger/willow-ui'
import { FC } from 'react'

import { AccountDetailLeadingIcon } from './header/AccountDetailLeadingIcon'
import { AccountDetailSubtitle } from './header/AccountDetailSubtitle'
import { AccountDetailTitle } from './header/AccountDetailTitle'
import {
  AccountDetailItemContainer,
  AccountDetailItemHeadingContainer,
} from './styles'
import { AccountDetailItemProps } from './types'

export const AccountDetailItem: FC<AccountDetailItemProps> = ({
  title,
  subtitle,
  accountDetailItemHeaderProps,
  leadingIcon,
  action,
  isVerified,
  children,
  isEditing = false,
}) => {
  return (
    <AccountDetailItemContainer data-is-editing={isEditing}>
      <AccountDetailItemHeadingContainer>
        {leadingIcon && (
          <AccountDetailLeadingIcon>{leadingIcon}</AccountDetailLeadingIcon>
        )}
        <Box
          $display="flex"
          $direction="column"
          $align="initial"
          $flex={1}
          $gap={2}
          {...accountDetailItemHeaderProps}
        >
          {title &&
            (typeof title === 'string' ? (
              <AccountDetailTitle>{title}</AccountDetailTitle>
            ) : (
              title
            ))}
          {subtitle &&
            (typeof subtitle === 'string' ? (
              <AccountDetailSubtitle>{subtitle}</AccountDetailSubtitle>
            ) : (
              subtitle
            ))}
        </Box>
        <Box $display="flex" $gap={4}>
          {isVerified && !isEditing && (
            <Badge $type="successLight" $size="sm" $rounded>
              Verified
            </Badge>
          )}
          {action}
        </Box>
      </AccountDetailItemHeadingContainer>
      {children}
    </AccountDetailItemContainer>
  )
}
